module.exports = {
  ownerId: '11111111111111111111111111111111',
  contractId: '4fJLR2GYTPFdomuTVvNy3VRrvWgvkKPzqehEBpNf2nk6',
};
